export const labelVariants = {
  thin: 'font-thin',
  normal: 'font-normal',
  semibold: 'font-semibold'
};

export const sizeVariants = {
  large: 'lg',
  medium: 'md',
  small: 'sm'
};

export const sizes = {
  small: 'p-1.5 text-sm',
  medium: 'p-2 text-base',
  large: 'p-3 text-lg'
};

export const labelSizes = {
  small: 'text-sm',
  medium: 'text-base',
  large: 'text-lg'
};

export const convertDate = (dateString?: string) => {
  if (!dateString) return;

  const date = new Date(dateString);

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();

  return `${hours}:${minutes} ${day}/${month}/${year}`;
};
